module.exports = __webpack_public_path__ + "img/loading.a5fec478.svg";